import React, { useState, useEffect } from "react";
import api from "../../../api";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { fetchEmployee } from "./store/employeeSlice";
import { useDispatch } from "react-redux";

const EditEmployeeData = ({ show, onClose, employeeId }) => {
  const [activeTab, setActiveTab] = useState("employeeinfo");
  const [isLoading, setIsLoading] = useState(false);
  const userType = localStorage.getItem("type");
  const [employeeData, setEmployeeData] = useState({
    sn: "",
    uan: "",
    pf_no: "",
    employee_code: "",
    first_name: "",
    last_name: "",
    gender: "",
    date_of_joining: "",
    date_of_birth: "",
    father_husband: "",
    aadhaar_no: "",
    email: "",
    phone: "",
    pan_no: "",
    employee_components: [
      {
        employee_component_id: "",
        component_name: "",
        component_value: "",
        is_calculated: 0,
      },
    ],
    attendance: {
      name: "",
      present_day: "",
      absent_day: "",
      paid_holiday: "",
      leave_addition_pl: "",
      leave_addition_cl: "",
      balance_leave: "",
      working_days_applicable: "",
      // month: "",
    },
    bank_details: {
      bank_name: "",
      branch: "",
      account_number: "",
      ifsc_code: "",
      bank_account_holder_name: "",
      swift_code: "",
    },
    tds: { tds_amount: "" },
    bonus: { bonus_amount: "" },
    earned_leave: { earned_leave_amount: "" },
    arrears: { arrears_amount: "" },
    reimbursement: { reimbursement_amount: "" },
  });
  const dispatch = useDispatch();

  const tabOrder = [
    "employeeinfo",
    "bankdetails",
    "attendance",
    "employeecomponents",
    "tds",
    "bonus",
    "earnedleave",
    "arrears",
    "reimbursement",
  ];

  useEffect(() => {
    if (show && employeeId) {
      fetchEmployeeData(employeeId);
    }
  }, [show, employeeId]);

  const fetchEmployeeData = async (id) => {
    try {
      const response = await api.post(`/edit-employee/${employeeId}`);
      if (response.data.status === 200) {
        const data = response.data.data || {};

        const ensureZeroOrValue = (value) => (value === 0 ? "0" : value || "");

        setEmployeeData({
          sn: ensureZeroOrValue(data.sn),
          uan: ensureZeroOrValue(data.uan),
          pf_no: ensureZeroOrValue(data.pf_no),
          employee_code: ensureZeroOrValue(data.employee_code),
          first_name: ensureZeroOrValue(data.first_name),
          last_name: ensureZeroOrValue(data.last_name),
          gender: ensureZeroOrValue(data.gender),
          date_of_joining: ensureZeroOrValue(data.date_of_joining),
          date_of_birth: ensureZeroOrValue(data.date_of_birth),
          father_husband: ensureZeroOrValue(data.father_husband),
          aadhaar_no: ensureZeroOrValue(data.aadhaar_no),
          email: ensureZeroOrValue(data.email),
          phone: ensureZeroOrValue(data.phone),
          pan_no: ensureZeroOrValue(data.pan_no),
          employee_components: data.employee_components?.map((comp) => ({
            employee_component_id: ensureZeroOrValue(comp.id),
            component_name: ensureZeroOrValue(comp.components?.component_name), // Fetch component_name
            component_value: ensureZeroOrValue(comp.value),
            is_calculated: comp.is_calculated || 0, // Ensure id_calculated is set
          })) || [
            {
              employee_component_id: "",
              component_name: "",
              component_value: "",
              is_calculated: 0,
            },
          ],
          bank_details: {
            bank_name: data.bank_details?.bank_name || "",
            branch: data.bank_details?.branch || "",
            account_number: data.bank_details?.account_number || "",
            ifsc_code: data.bank_details?.ifsc_code || "",
            bank_account_holder_name:
            data.bank_details?.bank_account_holder_name || "",
            swift_code: data.bank_details?.swift_code || "",
          },
          attendance: {
            name: ensureZeroOrValue(data.attendance?.[0]?.name),
            present_day: ensureZeroOrValue(data.attendance?.[0]?.present_day),
            absent_day: ensureZeroOrValue(data.attendance?.[0]?.absent_day),
            paid_holiday: ensureZeroOrValue(data.attendance?.[0]?.paid_holiday),
            leave_addition_pl: ensureZeroOrValue(
              data.attendance?.[0]?.leave_addition_pl
            ),
            leave_addition_cl: ensureZeroOrValue(
              data.attendance?.[0]?.leave_addition_cl
            ),
            balance_leave: ensureZeroOrValue(
              data.attendance?.[0]?.balance_leave
            ),
            working_days_applicable: ensureZeroOrValue(
              data.attendance?.[0]?.working_days_applicable
            ),
            // month: ensureZeroOrValue(data.attendance?.[0]?.month),
          },
          arrears: data.arrears?.[0]
            ? {
                arrears_amount: ensureZeroOrValue(data.arrears[0].amount),
                // arrears_month: ensureZeroOrValue(data.arrears[0].month),
              }
            : { arrears_amount: "" },
          tds: data.tds?.[0]
            ? {
                tds_amount: ensureZeroOrValue(data.tds[0].amount),
                // tds_month: ensureZeroOrValue(data.tds[0].month),
              }
            : { tds_amount: "" },
          bonus: data.bonus?.[0]
            ? {
                bonus_amount: ensureZeroOrValue(data.bonus[0].amount),
                // tds_month: ensureZeroOrValue(data.tds[0].month),
              }
            : { bonus_amount: "" },
          earned_leave: data.earned_leave?.[0]
            ? {
                earned_leave_amount: ensureZeroOrValue(
                  data.earned_leave[0].amount
                ),
                // tds_month: ensureZeroOrValue(data.tds[0].month),
              }
            : { tds_amount: "" },
          reimbursement: data.reimbursement?.[0]
            ? {
                reimbursement_amount: ensureZeroOrValue(
                  data.reimbursement[0].amount
                ),
                // reimbursement_month: ensureZeroOrValue(
                //   data.reimbursement[0].month
                // ),
              }
            : { reimbursement_amount: "" },
        });
      } else {
        console.error("Failed to fetch employee data:", response.data.message);
      }
    } catch (error) {
      console.error("An error occurred while fetching employee data:", error);
    }
  };

  const handleInputChange = (e, section, field, index = null) => {
    if (section === "employee_components" && index !== null) {
      const updatedComponents = [...employeeData.employee_components];
      updatedComponents[index][field] = e.target.value;
      setEmployeeData({
        ...employeeData,
        employee_components: updatedComponents,
      });
    } else if (section === "bank_details") {
      setEmployeeData({
        ...employeeData,
        bank_details: {
          ...employeeData.bank_details,
          [field]: e.target.value,
        },
      });
    } else {
      setEmployeeData((prevState) => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [field]: e.target.value,
        },
      }));
    }
  };

  const addEmployeeComponent = () => {
    setEmployeeData((prevState) => ({
      ...prevState,
      employee_components: [
        ...prevState.employee_components,
        { employee_component_id: "", component_value: "" },
      ],
    }));
  };

  const handleSaveAndNext = () => {
    const currentIndex = tabOrder.indexOf(activeTab);
    const nextIndex = (currentIndex + 1) % tabOrder.length;
    setActiveTab(tabOrder[nextIndex]);
  };

  const handleSaveAndClose = async () => {
    setIsLoading(true);
    const payload = {
      sn: employeeData.sn,
      uan: employeeData.uan,
      pf_no: employeeData.pf_no,
      employee_code: employeeData.employee_code,
      first_name: employeeData.first_name,
      last_name: employeeData.last_name,
      gender: employeeData.gender,
      date_of_joining: employeeData.date_of_joining,
      date_of_birth: employeeData.date_of_birth,
      father_husband: employeeData.father_husband,
      aadhaar_no: employeeData.aadhaar_no,
      email: employeeData.email,
      phone: employeeData.phone,
      pan_no: employeeData.pan_no,

      employee_components: employeeData.employee_components.map(
        (component) => ({
          employee_component_id: component.employee_component_id,
          component_value: component.component_value,
        })
      ),

      // Flatten attendance fields
      name: employeeData.attendance.name,
      present_day: employeeData.attendance.present_day,
      absent_day: employeeData.attendance.absent_day,
      paid_holiday: employeeData.attendance.paid_holiday,
      leave_addition_pl: employeeData.attendance.leave_addition_pl,
      leave_addition_cl: employeeData.attendance.leave_addition_cl,
      balance_leave: employeeData.attendance.balance_leave,
      working_days_applicable: employeeData.attendance.working_days_applicable,
      attendance_month: employeeData.attendance.month,

      bank_name: employeeData.bank_details.bank_name,
      branch: employeeData.bank_details.branch,
      account_number: employeeData.bank_details.account_number,
      ifsc_code: employeeData.bank_details.ifsc_code,
      bank_account_holder_name:
        employeeData.bank_details.bank_account_holder_name,
      swift_code: employeeData.bank_details.swift_code,

      // Flatten arrears fields
      arrears_amount: employeeData.arrears.arrears_amount,
      arrears_month: employeeData.arrears.arrears_month,

      // Flatten tds fields
      tds_amount: employeeData.tds.tds_amount,
      bonus_amount: employeeData.bonus.bonus_amount,
      earned_leave: employeeData.earned_leave.earned_leave_amount,
      tds_amount: employeeData.tds.tds_amount,
      tds_month: employeeData.tds.tds_month,

      // Flatten reimbursement fields
      reimbursement_amount: employeeData.reimbursement.reimbursement_amount,
      reimbursement_month: employeeData.reimbursement.reimbursement_month,
    };
    try {
      const response = await api.post(
        `/update-employee/${employeeId}`,
        payload
      );
      if (response.data.status === 200) {
        toast.success(response.data.message);

        onClose();
        dispatch(fetchEmployee());
      } else {
        console.log("test");
        toast.error(response.data.message);
      }
    } catch (error) {
      if (error.status === 500) {
        toast.error("Internal Server Error");
      } else {
        toast.error(error.response.data.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1050,
      }}
    >
      <div
        className="modal-dialog"
        style={{
          width: "90%",
          // maxWidth: "600px",
          height: "90vh",
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          className="modal-content p-2"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            borderRadius: "8px",
            boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.5)",
            backgroundColor: "#fff",
          }}
        >
          {/* Header */}
          <div
            className="modal-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderBottom: "1px solid #ddd",
              paddingBottom: "10px",
            }}
          >
            <h5 style={{ fontSize: "1.25rem", fontWeight: "bold" }}>
              Edit Employee Details
            </h5>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              style={{
                border: "none",
                backgroundColor: "transparent",
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>
          <div
            style={{
              padding: "0 20px 20px",
              overflowY: "auto",
              overflowx: "hidden",
              flex: "1",
            }}
          >
            <ul
              style={{
                display: "flex",
                listStyle: "none",
                padding: 0,
                marginBottom: "20px",
                borderBottom: "1px solid #ddd",
              }}
            >
              {[
                "Employee Info",
                "Bank Details",
                //"Attendance",
                "Employee Components",
                // "TDS",
                // "Bonus",
                // "Earned Leave",
                // "Arrears",
                // "Reimbursement",
              ].map((tab) => (
                <li
                  key={tab}
                  onClick={() =>
                    setActiveTab(tab.toLowerCase().replace(" ", ""))
                  }
                  style={{
                    cursor: "pointer",
                    padding: "10px 15px",
                    borderBottom:
                      activeTab === tab.toLowerCase().replace(" ", "")
                        ? "2px solid #ff9b44"
                        : "none",
                    fontWeight:
                      activeTab === tab.toLowerCase().replace(" ", "")
                        ? "bold"
                        : "normal",
                    color:
                      activeTab === tab.toLowerCase().replace(" ", "")
                        ? "#ff9b44"
                        : "#333",
                  }}
                >
                  {tab}
                </li>
              ))}
            </ul>

            {activeTab === "employeeinfo" && (
              <div>
                <form>
                  <div className="row">
                    {[
                      "sn",
                      "uan",
                      "pf_no",
                      "employee_code",
                      "first_name",
                      "last_name",
                      "gender",
                      "date_of_joining",
                      "date_of_birth",
                      "father_husband",
                      "aadhaar_no",
                      "email",
                      "phone",
                      "pan_no",
                    ].map((field) => (
                      <div
                        className="col-lg-3 mb-3"
                        key={field}
                        style={{ marginBottom: "15px", paddingRight: "15px" }}
                      >
                        <label
                          style={{
                            display: "block",
                            marginBottom: "5px",
                          }}
                        >
                          {field.replace(/_/g, " ").toUpperCase()}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          style={{
                            width: "100%",
                            padding: "8px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                          }}
                          value={employeeData[field] || ""}
                          onChange={(e) =>
                            setEmployeeData({
                              ...employeeData,
                              [field]: e.target.value,
                            })
                          }
                        />
                      </div>
                    ))}
                  </div>
                </form>
              </div>
            )}

            {activeTab === "bankdetails" && (
              <div>
                <form>
                  <div className="row">
                    {[
                      { label: "Bank Name", field: "bank_name" },
                      { label: "Branch", field: "branch" },
                      { label: "Account Number", field: "account_number" },
                      { label: "IFSC Code", field: "ifsc_code" },
                      {
                        label: "Account Holder Name",
                        field: "bank_account_holder_name",
                      },
                      { label: "SWIFT Code", field: "swift_code" },
                    ].map((item) => (
                      <div
                        className="col-lg-4 mb-3"
                        key={item.field}
                        style={{ marginBottom: "15px", paddingRight: "15px" }}
                      >
                        <label
                          style={{ display: "block", marginBottom: "5px" }}
                        >
                          {item.label}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={employeeData.bank_details?.[item.field] || ""}
                          onChange={(e) =>
                            handleInputChange(e, "bank_details", item.field)
                          }
                        />
                      </div>
                    ))}
                  </div>
                </form>
              </div>
            )}

            {activeTab === "attendance" && (
              <div>
                <form>
                  <div className="row">
                    {[
                      "name",
                      "present_day",
                      "absent_day",
                      "paid_holiday",
                      "leave_addition_pl",
                      "leave_addition_cl",
                      "balance_leave",
                      "working_days_applicable",
                    ].map((field) => (
                      <div
                        className="col-lg-3 mb-3"
                        key={field}
                        style={{ marginBottom: "15px", paddingRight: "15px" }}
                      >
                        <label
                          style={{
                            display: "block",
                            // fontWeight: "bold",
                            marginBottom: "5px",
                          }}
                        >
                          {field.replace(/_/g, " ").toUpperCase()}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          style={{
                            width: "100%",
                            padding: "8px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                          }}
                          value={employeeData.attendance[field] || ""}
                          onChange={(e) =>
                            handleInputChange(e, "attendance", field)
                          }
                          disabled={userType === "Admin"}
                        />
                      </div>
                    ))}
                  </div>
                </form>
              </div>
            )}

            {activeTab === "employeecomponents" && (
              <div
                style={{
                  maxHeight: "400px",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                {employeeData.employee_components.map((component, index) => (
                  <div className="row mb-3" key={index}>
                    <div className="col-lg-4">
                      <label>Component Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={component.component_name || ""}
                        readOnly={component.is_calculated === "1"} // Disable if id_calculated is 1
                        onChange={(e) =>
                          handleInputChange(
                            e,
                            "employee_components",
                            "component_name",
                            index
                          )
                        }
                        disabled={userType === "Admin"}
                      />
                    </div>
                    <div className="col-lg-4">
                      <label>Component Value</label>
                      <input
                        type="text"
                        className="form-control"
                        value={component.component_value || ""}
                        readOnly={component.is_calculated === "1"} // Disable if id_calculated is 1
                        onChange={(e) =>
                          handleInputChange(
                            e,
                            "employee_components",
                            "component_value",
                            index
                          )
                        }
                        disabled={userType === "Admin"}
                      />
                    </div>
                  </div>
                ))}
                {/* <button
      type="button"
      onClick={addEmployeeComponent}
      className="btn btn-primary"
      style={{ marginTop: "10px" }}
    >
      Add Component
    </button> */}
              </div>
            )}

            {activeTab === "tds" && (
              <div>
                <form>
                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <label>TDS Amount</label>
                      <input
                        type="text"
                        className="form-control"
                        value={employeeData.tds.tds_amount || ""}
                        onChange={(e) =>
                          handleInputChange(e, "tds", "tds_amount")
                        }
                        disabled={userType === "Admin"}
                      />
                    </div>
                    {/* <div className="col-lg-4 mb-3">
                      <label>TDS Month</label>
                      <input
                        type="text"
                        className="form-control"
                        value={employeeData.tds.tds_month || ""}
                        onChange={(e) =>
                          handleInputChange(e, "tds", "tds_month")
                        }
                      />
                    </div> */}
                  </div>
                </form>
              </div>
            )}

            {activeTab === "bonus" && (
              <div>
                <form>
                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <label>Bonus Amount</label>
                      <input
                        type="text"
                        className="form-control"
                        value={employeeData.bonus.bonus_amount || ""}
                        onChange={(e) =>
                          handleInputChange(e, "bonus", "bonus_amount")
                        }
                        disabled={userType === "Admin"}
                      />
                    </div>
                    {/* <div className="col-lg-4 mb-3">
                      <label>TDS Month</label>
                      <input
                        type="text"
                        className="form-control"
                        value={employeeData.tds.tds_month || ""}
                        onChange={(e) =>
                          handleInputChange(e, "tds", "tds_month")
                        }
                      />
                    </div> */}
                  </div>
                </form>
              </div>
            )}

            {activeTab === "earnedleave" && (
              <div>
                <form>
                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <label>Earned Leave Amount</label>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          employeeData.earned_leave.earned_leave_amount || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            e,
                            "earned_leave",
                            "earned_leave_amount"
                          )
                        }
                        disabled={userType === "Admin"}
                      />
                    </div>
                    {/* <div className="col-lg-4 mb-3">
                      <label>TDS Month</label>
                      <input
                        type="text"
                        className="form-control"
                        value={employeeData.tds.tds_month || ""}
                        onChange={(e) =>
                          handleInputChange(e, "tds", "tds_month")
                        }
                      />
                    </div> */}
                  </div>
                </form>
              </div>
            )}

            {activeTab === "arrears" && (
              <div>
                <form>
                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <label>Arrears Amount</label>
                      <input
                        type="text"
                        className="form-control"
                        value={employeeData.arrears.arrears_amount || ""}
                        onChange={(e) =>
                          handleInputChange(e, "arrears", "arrears_amount")
                        }
                        disabled={userType === "Admin"}
                      />
                    </div>
                    {/* <div className="col-lg-4 mb-3">
                      <label>Arrears Month</label>
                      <input
                        type="text"
                        className="form-control"
                        value={employeeData.arrears.arrears_month || ""}
                        onChange={(e) =>
                          handleInputChange(e, "arrears", "arrears_month")
                        }
                      />
                    </div> */}
                  </div>
                </form>
              </div>
            )}

            {activeTab === "reimbursement" && (
              <div>
                <form>
                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <label>Reimbursement Amount</label>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          employeeData.reimbursement.reimbursement_amount || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            e,
                            "reimbursement",
                            "reimbursement_amount"
                          )
                        }
                        disabled={userType === "Admin"}
                      />
                    </div>
                    {/* <div className="col-lg-4 mb-3">
                      <label>Reimbursement Month</label>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          employeeData.reimbursement.reimbursement_month || ""
                        }
                        onChange={(e) =>
                          handleInputChange(
                            e,
                            "reimbursement",
                            "reimbursement_month"
                          )
                        }
                      />
                    </div> */}
                  </div>
                </form>
              </div>
            )}
          </div>
          {/* Footer with Save Buttons */}
          <div
            className="modal-footer"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingTop: "15px",
            }}
          >
            <button
              type="button"
              onClick={onClose}
              style={{
                backgroundColor: "#6c757d",
                color: "#fff",
                padding: "5px 10px",
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
                marginRight: "10px",
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSaveAndNext}
              style={{
                backgroundColor: "#ff9b44",
                color: "#fff",
                padding: "5px 10px",
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
                marginRight: "10px",
              }}
            >
              Next
            </button>
            <button
              type="button"
              onClick={handleSaveAndClose}
              disabled={isLoading}
              style={{
                backgroundColor: "#28a745",
                color: "#fff",
                padding: "5px 10px",
                borderRadius: "4px",
                border: "none",
                cursor: "pointer",
              }}
            >
              {isLoading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2" // Add margin to the right
                />
              )}
              Save and Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEmployeeData;
